// Wording follows the artifact's decide() function; dynamic values come from the API.
export function futureSellingConclusion({ mode, date, cap, available, count, stockoutTransition, capTransition, b2bTransition }) {
    const formatDate = (value) => new Date(`${value}T00:00:00`).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
    const limit = cap === '' || cap === null ? null : Number(cap)
    const suffix = b2bTransition ? ' Vente B2B passée en Rupture forcée par le BO.' : ''
    const result = (color, title, text) => ({ color, title, text: text + suffix })

    if (mode === 'force_disabled') {
        return result('red', 'Rupture.', 'Aucune vente B2C.' + (capTransition
            ? ` Plafond atteint (${count} précommandes sur ${limit}) : le BO a passé « Vente B2C » sur « Rupture forcée ».` : ''))
    }
    if (mode === 'force_available') {
        return result('gray', 'En stock, sans limite.', 'Vendable même en rupture, expédition annoncée le jour ouvré suivant. Pour annoncer une date, passer en « Précommande ».')
    }
    if (mode === 'preorder' && !date) {
        return result('red', 'Enregistrement impossible.', "Saisis une date d'expédition pour passer en Précommande.")
    }
    if (mode === 'follow') {
        if (available > 0) {
            return result('green', 'En stock.', `Vendable : ${available}, expédition le jour ouvré suivant. Rien ne change pour le client.` + (date
                ? ` Rupture anticipée prête : quand le disponible tombera à 0, le BO passera « Vente B2C » sur « Précommande », expédition le ${formatDate(date)}` + (limit !== null
                    ? `, jusqu'à ${limit} pièces vendues en précommande.` : ', sans limite.') : ''))
        }
        if (!date) return result('red', 'Rupture.', `Disponible à ${available} et aucune date d'expédition saisie.`)
    }
    const transition = stockoutTransition ? ' Bascule faite par le BO quand le disponible a atteint 0.' : ''
    const dispatch = ` Expédition le ${formatDate(date)}.`
    if (limit === null) return result('orange', 'Précommande, sans limite.', `${count} déjà vendues.${transition}${dispatch}`)
    if (count < limit) return result('orange', 'Précommande.', `Encore vendable : ${limit - count} (plafond ${limit} − ${count} déjà vendues), quel que soit le stock.${transition}${dispatch}`)
    return result('red', 'Rupture.', `Plafond atteint : ${count} précommandes sur ${limit}.`)
}
